import { IStudentRow } from 'types';

export const areStudentsEqual = (prev: Array<IStudentRow> | null, next: Array<IStudentRow> | null): boolean => {
  return prev?.length === next?.length;
};
